// Arab Sanad brand assets — official logo + curated section thumbnails.
// Images curated Feb 2026 to match the master design references:
// warm sunset / premium photography style across all sections.

export const ARAB_SANAD_LOGO = "/arab-sanad-logo.jpg";

// Fallback used if the local logo ever fails to load — full-res PNG version of the same logo.
export const ARAB_SANAD_LOGO_FALLBACK = "/arab-sanad-logo.png";

// Hero / login background — Statue of Liberty + One WTC + NY skyline at golden-hour sunset
// (User-provided exact reference image, served locally from /public for fast load + offline reliability)
export const NY_SUNSET_BG = "/hero-ny-sunset.jpg";

// Fallback used if NY_SUNSET_BG ever fails to load — neutral NY skyline at sunset (Unsplash CDN).
export const NY_SUNSET_BG_FALLBACK = "https://images.unsplash.com/photo-1546436836-07a91091f160?w=1920&q=85&auto=format&fit=crop";

// 3D Robot AI Assistant — friendly white robot
export const ROBOT_ASSISTANT = "https://images.unsplash.com/photo-1535378620166-273708d44e4c?w=400&h=400&fit=crop&q=85";

// Category & sidebar thumbnails — curated to match references exactly
export const NAV_THUMBS = {
  "/dashboard":         "https://images.unsplash.com/photo-1546436836-07a91091f160?w=400&h=300&fit=crop&q=85",
  "/ai-assistant":      "https://images.unsplash.com/photo-1535378620166-273708d44e4c?w=400&h=300&fit=crop&q=85",
  // Jobs — professional meeting in suits, indoor warm lighting
  "/jobs":              "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop&q=85",
  // Housing — modern luxury home at golden-hour twilight
  "/housing":           "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop&q=85",
  // Cars — luxury black SUV
  "/vehicles":          "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=600&h=400&fit=crop&q=85",
  // Community — group of friends sitting together, laughing & interacting
  "/community":         "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=600&h=400&fit=crop&q=85",
  // Arab Sanad TV — film studio with lights/cameras
  "/tv":                "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=600&h=400&fit=crop&q=85",
  // Education — graduation cap on books with warm light
  "/education":         "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=600&h=400&fit=crop&q=85",
  // Services — community helping/business
  "/services":          "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&h=300&fit=crop&q=85",
  // Discover America — mountain landscape with lake reflection
  "/discover":          "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&h=400&fit=crop&q=85",
  // Airport pickup — luxury car at airport / transportation
  "/airport-pickup":    "https://images.unsplash.com/photo-1556122071-e404eaedb77f?w=600&h=400&fit=crop&q=85",
  // Documents — passport + paperwork
  "/documents":         "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop&q=85",
  // Messages — chat communication
  "/messages":          "https://images.unsplash.com/photo-1611606063065-ee7946f0787a?w=400&h=300&fit=crop&q=85",
  "/chat/inbox":        "https://images.unsplash.com/photo-1611606063065-ee7946f0787a?w=400&h=300&fit=crop&q=85",
  // Resume Center — professional CV / business person
  "/cv":                "https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=600&h=400&fit=crop&q=85",
  // Profile — friendly portrait
  "/profile":           "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=400&h=300&fit=crop&q=85",
  // Settings
  "/settings":          "https://images.unsplash.com/photo-1593062037896-764e9f52029e?w=400&h=300&fit=crop&q=85",
  "/admin":             "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop&q=85",
  "/subscriptions":     "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop&q=85",
  "/favorites":         "https://images.unsplash.com/photo-1518049362265-d5b2a6467637?w=400&h=300&fit=crop&q=85",
  "/grocery":           "https://images.unsplash.com/photo-1542838132-92c53300491e?w=400&h=300&fit=crop&q=85",
  "/guide":             "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&h=300&fit=crop&q=85",
};

// Promo card — Golden Gate / mountain at sunset
export const PROMO_MOUNTAINS = "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&h=400&fit=crop&q=85";

// Promo card — Arab Sanad TV / film studio (wide aspect)
export const PROMO_TV_STUDIO = "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=1200&h=600&fit=crop&q=85";
